module.exports = __webpack_public_path__ + "static/media/simple-line-icons_check.84e0e535.png";